import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DeliveryMethodService} from 'app/blocks/service/api/delivery-method.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IDeliveryMethod} from 'app/blocks/model/delivery-method.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {DeliveryMethod} from 'app/blocks/model/delivery-method.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class DeliveryMethodResource extends AbstractEntityResource<IDeliveryMethod> {
    constructor(deliveryMethodService: DeliveryMethodService, router: Router) {
        super(
            Resource.DELIVERY_METHODS,
            deliveryMethodService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_METHODS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.DELIVERY_METHODS),
            (entity?) => new DeliveryMethod(entity),
            (entity) => entity.code
        );
    }
}
